import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getRoot, getParent, types } from 'mobx-state-tree';
import moment from 'moment/moment';
const UtilityTypeModel = types.model('UtilityTypeModel', {
  utilityId: types.string,
  utilityTypeId: types.string,
  utilityTypeName: types.string,
  utilityProviderName: types.maybeNull(types.string),
  utilityCap: types.maybeNull(types.number)
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        store[key] = value;
      });
    }
  };
});
const UnitDataModel = types.model('UnitDataModel', {
  id: types.string,
  name: types.string,
  occupancy: types.number,
  squareFootage: types.number,
  type: types.string,
  inUnitAmenities: types.optional(types.array(UtilityTypeModel), []),
  utilityIds: types.optional(types.array(UtilityTypeModel), [])
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref3 => {
        let _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        store[key] = value;
      });
    }
  };
});
const StatementInfoModel = types.model('StatementInfoModel', {
  month: types.number,
  statementId: types.string,
  timestamp: types.string,
  year: types.number
});
const FinalStatementModel = types.model('FinalStatementModel', {
  fseId: types.maybeNull(types.string),
  fseReviewDaysPeriod: types.number,
  moveOutDate: types.string,
  avaliableFrom: types.string,
  overdueDays: types.number,
  residencyId: types.maybeNull(types.string),
  statement: types.maybeNull(StatementInfoModel),
  status: types.string,
  totalCharge: types.number
});
export const PropertyUnitModel = types.model('PropertyUnitModel', {
  firstname: types.maybeNull(types.string),
  lastname: types.maybeNull(types.string),
  fullname: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  newEmail: types.maybeNull(types.string),
  emailConfirmed: types.maybeNull(types.boolean),
  portalAccessDateOnly: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  unitData: UnitDataModel,
  finalStatement: types.maybeNull(FinalStatementModel),
  residencyId: types.maybeNull(types.string),
  // NOTE: match helper id
  accountId: types.maybeNull(types.string),
  // // NOTE: match helper id
  unitId: types.string,
  // NOTE: primaryId
  portfolioId: types.maybeNull(types.string),
  portfolioIds: types.optional(types.array(types.string), []),
  propertyId: types.string,
  unitName: types.string,
  enrolledDateOnly: types.maybeNull(types.string),
  billingStartDateOnly: types.maybeNull(types.string),
  moveOutDateOnly: types.maybeNull(types.string),
  residencyUtilities: types.optional(types.array(UtilityTypeModel), []),
  residencyUtilityOptOuts: types.optional(types.array(UtilityTypeModel), []),
  statementCap: types.maybeNull(types.number),
  unitUtilityOptOuts: types.optional(types.array(UtilityTypeModel), []),
  occupancy: types.number,
  currentBalance: types.maybeNull(types.number),
  accountBalanceStatus: types.maybeNull(types.string),
  averageStatement: types.maybeNull(types.number),
  isAutoPayEnabled: types.boolean,
  lastFetchTime: types.optional(types.number, moment().toDate().getTime())
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref5 => {
        let _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        switch (key) {
          // case 'residencyUtilities':
          //   store.residencyUtilities.updateModel(value);
          //   break;
          // case 'residencyUtilityOptOuts':
          //   store.residencyUtilityOptOuts.updateModel(value);
          //   break;
          // case 'unitUtilityOptOuts':
          //   store.unitUtilityOptOuts.updateModel(value);
          //
          //   break;
          case 'unitData':
            store.unitData.updateModel(value);
            break;
          default:
            store[key] = value;
        }
      });
    }
  };
}).views(store => ({
  get unitPropertyInfo() {
    const propertParentLevel = getParent(getParent(store));
    return propertParentLevel;
  },
  get unitPropertyPortfolioInfo() {
    const portfolioParentLevel = store.unitPropertyInfo.propertyPortfolioInfo;
    return portfolioParentLevel;
  },
  get unitPropertyAddress() {
    var _store$unitPropertyIn;
    return (_store$unitPropertyIn = store.unitPropertyInfo.propertyInformation) === null || _store$unitPropertyIn === void 0 || (_store$unitPropertyIn = _store$unitPropertyIn.address) === null || _store$unitPropertyIn === void 0 ? void 0 : _store$unitPropertyIn.addressString;
  },
  get unitPortfolioName() {
    var _store$unitPropertyPo;
    return (_store$unitPropertyPo = store.unitPropertyPortfolioInfo) === null || _store$unitPropertyPo === void 0 ? void 0 : _store$unitPropertyPo.name;
  },
  get residencyUtilityIds() {
    var _store$residencyUtili, _store$residencyUtili2, _store$unitUtilityOpt, _store$unitData;
    return [...(store === null || store === void 0 || (_store$residencyUtili = store.residencyUtilities) === null || _store$residencyUtili === void 0 ? void 0 : _store$residencyUtili.map(utility => utility.utilityId)), ...(store === null || store === void 0 || (_store$residencyUtili2 = store.residencyUtilityOptOuts) === null || _store$residencyUtili2 === void 0 ? void 0 : _store$residencyUtili2.map(utility => utility.utilityId)), ...(store === null || store === void 0 || (_store$unitUtilityOpt = store.unitUtilityOptOuts) === null || _store$unitUtilityOpt === void 0 ? void 0 : _store$unitUtilityOpt.map(utility => utility.utilityId)), ...(store === null || store === void 0 || (_store$unitData = store.unitData) === null || _store$unitData === void 0 || (_store$unitData = _store$unitData.utilityIds) === null || _store$unitData === void 0 ? void 0 : _store$unitData.map(utility => utility.utilityId))].flat();
  },
  get isEnrolmentScheduled() {
    return store !== null && store !== void 0 && store.enrolledDateOnly ? moment(getRoot(store).properties.serverBusinessDateOnly).isBefore(moment(store.enrolledDateOnly)) : undefined;
  }
}));